import { Home, BarChart2, Search } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { cn } from "@/lib/utils";

export function MobileNavigation() {
  const location = useLocation();
  
  const navigation = [
    {
      name: "Feed",
      href: "/",
      icon: Home,
    },
    {
      name: "Analytics",
      href: "/analytics",
      icon: BarChart2,
    },
    {
      name: "Search",
      href: "/search",
      icon: Search,
    },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 md:hidden">
      <div className="flex justify-around items-center h-16">
        {navigation.map((item) => {
          const isActive = location.pathname === item.href;
          return (
            <Link
              key={item.name}
              to={item.href}
              className={cn(
                "flex flex-col items-center justify-center w-full h-full",
                "text-sm font-medium transition-colors",
                isActive
                  ? "text-nutrition-600"
                  : "text-gray-500 hover:text-nutrition-500"
              )}
            >
              <item.icon className="h-6 w-6" />
              <span className="mt-1 text-xs">{item.name}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}